/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React from "react";
import { Button, Box } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const AttachmentDownloadButton = ({ downloadLink }) => {
  //! handledownload for download the file in current tab
  const handleDownload = async () => {
    try {
      // Fetch the image
      const response = await fetch(downloadLink);
      const blob = await response.blob();

      // Create a link element
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);

      // Extract filename from URL (or use a default)
      const filename = downloadLink.split("/").pop().split("?")[0];
      link.download = filename;

      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the object URL
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download the image");
    }
  };

  return (
    <Button
      sx={{
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        minWidth: "40px",
        padding: 0,
      }}
      variant="contained"
      color="primary"
      onClick={handleDownload}
    >
      <FileDownloadIcon />
    </Button>
  );
};

export default AttachmentDownloadButton;
